import { push } from "connected-react-router";
import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { getDateString } from "common/date-utils";
import { exportName } from "common/constants/exportName";
import { InsGridWidget } from "components/widgets";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import usePageTitle from "hooks/use-page-title";
import { language } from "language/default";
import { useGetAllFundSeries } from "./api";
import { AuxGridColumnType } from "@blk/aladdin-react-components-es";
import { setSelectedRowsState } from "store/grids";
import { InsDeleteFundSeriesAction } from "./InsDeleteFundSeriesAction";
export const insFundSeriesListStateId = "all-fund-series-grid";
const getValueFormatter = (params) => {
    const { value } = params;
    if (!value) {
        return "";
    }
    if (value instanceof Date) {
        return getDateString(value);
    }
    if (typeof value === "string" && value.trim() === "") {
        return "";
    }
    return getDateString(new Date(value));
};
export const FundSeriesListColDefs = [
    {
        field: "checkboxCol",
        floatingFilter: false,
        headerCheckboxSelection: true,
        headerName: " ",
        type: AuxGridColumnType.AUX_CHECKBOX_COLUMN,
        width: 32
    },
    {
        field: "name",
        flex: 2,
        headerName: language.en.fundSeries.gridHeaderField.name,
        initialSort: "asc",
        minWidth: 200,
        type: [CustomColumnType.InsLinkColumn]
    },
    {
        field: "assetClass",
        flex: 1,
        headerName: language.en.fundSeries.gridHeaderField.assetClass,
        maxWidth: 120,
        minWidth: 100,
        type: [CustomColumnType.AUX_TEXT_COLUMN]
    },
    {
        field: "strategy",
        flex: 1,
        headerName: language.en.fundSeries.gridHeaderField.strategy,
        minWidth: 150,
        type: [CustomColumnType.AUX_TEXT_COLUMN]
    },
    {
        field: "fundManager",
        flex: 1.5,
        headerName: language.en.fundSeries.gridHeaderField.fundManager,
        minWidth: 180,
        type: [CustomColumnType.AUX_TEXT_COLUMN]
    },
    {
        cellClass: "right-aligned-cell",
        field: "fundsInSeries",
        flex: 0.8,
        headerClass: "right-aligned-header",
        headerName: language.en.fundSeries.gridHeaderField.fundsInSeries,
        maxWidth: 150,
        minWidth: 120,
        type: [CustomColumnType.AUX_TEXT_COLUMN]
    },
    {
        cellClass: "center-aligned-cell",
        field: "asAtDate",
        flex: 1,
        headerClass: "center-aligned-header",
        headerName: language.en.fundSeries.gridHeaderField.asAtDate,
        minWidth: 130,
        type: [CustomColumnType.AUX_DATE_COLUMN],
        valueFormatter: (params) => getValueFormatter(params)
    },
    {
        cellClass: "center-aligned-cell",
        field: "dateUploaded",
        flex: 1,
        headerClass: "center-aligned-header",
        headerName: language.en.fundSeries.gridHeaderField.dateUploaded,
        minWidth: 140,
        type: [CustomColumnType.AUX_DATE_COLUMN],
        valueFormatter: (params) => getValueFormatter(params)
    }
];
export const InsFundSeriesList = () => {
    usePageTitle(`${language.en.common.titles.fundSeries} - ${language.en.common.titles.base}`);
    const dispatch = useDispatch();
    const exportFundSeriesName = `${exportName.FundSeries}_List`;
    const [data, querystate, refresh] = useGetAllFundSeries();
    const rows = data.map((row) => ({
        ...row,
        name: {
            label: row.name,
            onclick: () => {
                dispatch(push(`/fund-series/${row.id}`));
            }
        }
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "dashboardHeaderTitle" }, language.en.fundSeries.listTitle),
        React.createElement(InsGridWidget, { suppressExcelExport: false, exportExcelName: exportFundSeriesName, stateId: insFundSeriesListStateId, rowData: rows, columnDefs: FundSeriesListColDefs, reduceHeight: true, refreshAction: refresh, queryState: querystate, selectionMode: "multiple", suppressRowClickSelection: true, rowSelectedHandler: (e) => {
                dispatch(setSelectedRowsState({
                    id: insFundSeriesListStateId,
                    selectedRows: e.api.getSelectedRows().map((row) => row.id)
                }));
            }, additionalNodes: [
                React.createElement(Fragment, { key: "fundSeries-additional-nodes" },
                    React.createElement(InsDeleteFundSeriesAction, null))
            ] })));
};
